import {HttpResponse} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {
  ITEMS_PER_PAGE,
  PAGE_SIZE_OPTIONS,
} from '@shared/constants/pagination.constants';
import {IDonVi} from '@entities/don-vi/don-vi.model';
import {DonViService} from '@entities/don-vi/don-vi.service';

@Component({
  selector: 'app-don-vi-list',
  templateUrl: './don-vi.component.html',
  styleUrls: ['./don-vi.component.scss'],
})
export class DonViComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'id',
    'tenDonVi',
    'telephone',
    'dienTichDat',
    'address',
    'action',
  ];
  dataSource: any;
  pageSizeOptions: number[];
  ELEMENT_DATA: IDonVi[];
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  currentSearch: string;
  routeData: any;
  eventSubscriber: Subscription;
  isLoading = true;
  constructor(
    private donViService: DonViService,
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private parseLinks: JhiParseLinks,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.ELEMENT_DATA = [];
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
    this.routeData = this.activatedRoute.data.subscribe(({pagingParams}) => {
      this.page = pagingParams.page;
      this.previousPage = pagingParams.page;
      this.reverse = pagingParams.ascending;
      this.predicate = pagingParams.predicate;
    });

    this.currentSearch =
      this.activatedRoute.snapshot &&
      this.activatedRoute.snapshot.params['search']
        ? this.activatedRoute.snapshot.params['search']
        : '';
  }

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.donVi.donVi.list'),
    );
    this.loadAll();
    this.changedListDonVi();
  }

  ngOnDestroy() {
    this.eventManager.destroy(this.eventSubscriber);
  }

  changedListDonVi() {
    this.eventSubscriber = this.eventManager.subscribe(
      'donViListModification',
      (response) => this.loadAll(),
    );
  }

  loadAll() {
    this.isLoading = true;
    if (this.currentSearch) {
      this.donViService
        .search({
          page: this.page - 1,
          query: this.currentSearch,
          size: this.itemsPerPage,
          sort: this.sort(),
        })
        .subscribe(
          (res: HttpResponse<IDonVi[]>) =>
            this.onSuccess(res.body, res.headers),
          (res: HttpResponse<any>) => this.onError(res.body),
        );
      return;
    }
    this.donViService
      .query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      })
      .subscribe(
        (res: HttpResponse<IDonVi[]>) => this.onSuccess(res.body, res.headers),
        (res: HttpResponse<any>) => this.onError(res.body),
      );
  }

  private sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.transition();
  }

  clear() {
    this.page = 1;
    this.currentSearch = '';
    this.loadAll();
  }

  search(query: any) {
    if (!query) {
      return this.clear();
    }
    this.page = 1;
    this.currentSearch = query;
    this.loadAll();
  }

  private transition() {
    this.loadAll();
  }

  private onSuccess(data: any, headers: any) {
    this.isLoading = false;
    this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.ELEMENT_DATA = data;
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  }

  private onError(error: any) {
    this.isLoading = false;
    this.alertService.error(error.error, error.message, null);
  }
  convertAddress(data) {
    return [data.address, data.ward, data.district, data.city]
      .filter(Boolean)
      .join(', ');
  }
}
